import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { EditorBookingItemSettingCapacity } from '../editor-booking-item-setting/editor-booking-item-setting-capacity.model';


@Component({
    selector: 'eas-editor-booking-item-setting-value-capacity',
    templateUrl: './editor-booking-item-setting-value.component.html',
    standalone: false
})
export class EditorBookingItemSettingValueCapacityComponent implements OnChanges, OnInit {
  @Input() itemSetting: EditorBookingItemSettingCapacity;

  value: string;

  constructor() {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.value = this.getValue();
    }
  }

  getValue(): string {
    let value = '';

    if (this.itemSetting.available !== null) {
      value = `${this.itemSetting.available}`;
    }

    return value;
  }
}
